export default __webpack_public_path__ + "static/media/mov.821c8e9f.png";